import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../state/store";
import { Line } from "react-chartjs-2";
import { Check } from "../../components/Check/Check";
import { DataTable } from "../../components/DataTable/DataTable";
import { Row } from "../../components/Row";
import { useRequestHandler } from "../../hooks/requestHandler";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { logOut, SET_LOGOUT } from "../../state/actions/authentication";
import dayjs from "dayjs";

export function UserInfo() {
  useDocumentTitle("My Account - Bible Quiz Academy");
  const dispatch = useAppDispatch();
  const [view, setView] = useState<"USER" | "SIGNOUT">("USER");
  const [signOutData, setSignOutData] = useState<any>({});
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.authentication);
  const { usage, allWeeksUsage, rolling } = useAppSelector(
    (state) => state.appDetails
  );
  const finishSignout = () => {
    if (signOutData.removeData) {
      localStorage.clear();
      window.location.assign("/");
    } else {
      dispatch({ type: SET_LOGOUT });
      navigate("/");
    }
  };
  const handler = useRequestHandler({
    onSuccess: (key) => {
      if (key === "SIGNOUT") {
        finishSignout();
      }
    },
    onError: (key) => {
      if (key === "SIGNOUT") {
        finishSignout();
      }
    },
  });

  if (!user) return <Navigate to="/" />;

  const getTournamentAccessConent = () => {
    const { tournamentAccess } = user.securityClearance;
    if (!tournamentAccess || tournamentAccess.length === 0) return null;
    let result = "Tournament Access: ";
    tournamentAccess.forEach((ministry, index) => {
      result = `${result}${index > 0 ? ", " : ""}${ministry}`;
    });

    return <p>{result}</p>;
  };

  const getMainContent = () => {
    switch (view) {
      case "USER":
        return (
          <div>
            <p>{`Username: ${user.userName}`}</p>
            <p>{`Email: ${user.email}`}</p>
            {getTournamentAccessConent()}
            {usage.length > 0 && (
              <Row>
                <DataTable
                  columns={[
                    {
                      title: "Date",
                      property: "date",
                      render: (obj) => obj.date,
                      sortFunc: true,
                    },
                    {
                      title: "Ping Count",
                      property: "p",
                      render: (obj) => obj.p,
                      sortFunc: true,
                    },
                  ]}
                  data={usage}
                  getKey={(obj) => obj.date}
                  style={{ width: 400 }}
                  defaultSort={{
                    property: "date",
                    direction: "desc",
                  }}
                />
                <Line
                  style={{ maxWidth: 600, maxHeight: 600, marginLeft: 20 }}
                  data={{
                    labels: allWeeksUsage.map((week) => week.date),
                    datasets: [
                      {
                        data: allWeeksUsage.map((week, index) => {
                          let days = 7;
                          if (index + 1 === allWeeksUsage.length) {
                            days =
                              Math.floor(
                                dayjs().diff(dayjs(week.date), "days")
                              ) + 1;
                          }
                          return Math.round(week.p / days);
                        }),
                        label: "Ping Count",
                        borderColor: "red",
                        backgroundColor: "red",
                      },
                      {
                        data: [
                          ...Array(52).fill(null),
                          ...rolling.map((week) => week.p),
                        ],

                        label: "Rolling Year",
                        borderColor: "green",
                        backgroundColor: "green",
                      },
                    ],
                  }}
                  options={{
                    scales: {
                      y: {
                        suggestedMin: 0,
                      },
                    },
                  }}
                />
              </Row>
            )}

            <div>
              <button
                className="link"
                style={{ paddingLeft: 0 }}
                onClick={() => setView("SIGNOUT")}
              >
                Sign Out
              </button>
            </div>
          </div>
        );
      case "SIGNOUT":
        return (
          <div>
            <p>You can sign back in at any time</p>
            <Check
              checked={signOutData.removeData}
              onClick={(checked) => {
                setSignOutData({
                  ...signOutData,
                  removeData: checked,
                });
              }}
              style={{ width: 310 }}
            >
              Remove all BQA data from this device
            </Check>
            <p>
              If you have settings or quizzes from Scorekeeper, you can remove
              them from this device only when you signout.
            </p>
            <Row>
              <button
                className="secondary-btn"
                onClick={() => {
                  handler.runRequest(
                    logOut(),
                    "Signing out...",
                    "You have logged out!",
                    "SIGNOUT"
                  );
                }}
              >
                Sign Out
              </button>
              <button
                className="secondary-btn"
                style={{ marginLeft: 10 }}
                onClick={() => setView("USER")}
              >
                Cancel
              </button>
            </Row>
          </div>
        );
    }
  };
  return (
    <div className="page">
      {handler.snackbar}
      <Row>
        <Link className="secondary-btn" to="/">
          Back to Menu
        </Link>
        <h1 style={{ marginLeft: 20 }}>My Account</h1>
      </Row>
      {getMainContent()}
    </div>
  );
}
